import React from 'react'

const AppLocationContext = React.createContext<React.RefObject<HTMLDivElement> | null>(null)

export default AppLocationContext
